/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import * as CustomWidgets from "../customwidgets";
import DataTable from "react-data-table-component";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles } from "../../util/TableStyles"
import { noDataComponent } from "../../util/DataObject"

const DataTables = (props) => {
  const [headers, setHeaders] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    setHeaders(JSON.parse(JSON.stringify(props.headers)));
    for (let i = 0; i < props.data.length; i++) {
      props.data[i]["checked"] = false;
      props.data[i]["showInfo"] = false;
    }
    setData(JSON.parse(JSON.stringify(props.data)));
  }, [props.data]);

  const changeCheck = (item, index) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].uuid === item.uuid && index !== i) {
        index = i;
      }
    }

    let d = data;
    for (let i = 0; i < d.length; i++) {
      if (i != index) {
        if (d[i]["checked"]) {
          d[i]["checked"] = !d[i]["checked"];
        }
      }
    }

    d[index]["checked"] = !d[index]["checked"];
    setData(JSON.parse(JSON.stringify(d)));
    if (d[index]["checked"]) {
      props.changeRadio(d[index]);
    } else {
      props.changeRadio({});
    }
  };

  //   ------------------------------------------------------------------
  const columns = [
    { selector: (row) => props.hasAction("cardNumber") ? row.pan : row.pan.substring(0,6)+'******'+ row.pan.substring(row.pan.length-4), name: "Número de tarjeta", sortable: true },
    { selector: (row) => row.typeParse, name: "Tipo de tarjeta", sortable: true },
    { selector: (row) => row.status, name: "Estatus", sortable: true },
    { selector: (row) => row.accountNumber, name: "Número de cuenta", sortable: true },
    {
      cell: (item, index) => {
        return (
          <div className={`radio_in_table`}>
            <input
              className="cmn_radio"
              name="radio-tbl"
              type="radio"
              data-tag="allowRowEvents"
              value={item.uuid}
              id={`rad-${index}`}
              onChange={changeCheck.bind(this, item, index)}
              checked={item.checked}
            />
            <label htmlFor={`rad-${index}`}></label>
          </div>
        );
      },
      sortable: true,
    },
  ];

  const selectInfo = (item, index) => (
    <div className="select_info">
      <CustomWidgets.CardInfo
        data={{ card: item.data }}
        key={`card-info-${item.index}`}
      />
    </div>
  );

  return (
    <div style={{ width: "96%", margin: "auto", marginBottom: "30px"  }}>
      <ThemeProvider theme={theme}>
        <DataTable
          columns={columns}
          data={data}
          expandableRows={true}
          expandOnRowClicked={false}
          expandableRowsComponent={selectInfo}
          customStyles={customStyles}
          noDataComponent={noDataComponent}
        />
      </ThemeProvider>
    </div>
  );
};

export default DataTables;
